import {PHASES, WAR_PHASE_STAGES} from "../../constants/phases";
import {checkIfNewUnitSelected} from "../gameState/checkIfNewUnitSelected";
import {checkIfFinalRoundOf} from "../checkIfFinalRound";

export const isNewUnitRecruitmentMarkersShown = (selectedToken, sharedGameState) => {
  // В последнем раунде найм новых отрядов запрещен (клик по казарме отвечает
  // тостом — см. GameScene), поэтому казармы не выделяются ни особой картинкой
  // (см. checkIfBarracksCanRecruitNewUnit), ни аутлайн-маркером: и то и другое
  // обещало бы действие, которого нет
  if (checkIfFinalRoundOf(sharedGameState.round, sharedGameState.finalRound)) {
    return false;
  }

  return sharedGameState.phase === PHASES.WAR
    && sharedGameState.warPhaseStage === WAR_PHASE_STAGES.RECRUITMENT
    && checkIfNewUnitSelected(selectedToken)
}